export default "__VITE_PUBLIC_ASSET__b8ad75a2__"